import JumboDdMenu from "@jumbo/components/JumboDdMenu";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { Button } from "@mui/material";
import { postUploadAgendaFileApi } from "api/meeting";
import { sendMailByMeetingIdPDFApi } from "api/notification";
import { getOneRecordByIdPDFApi, getPDFForEachDecisionByMeetingIdPDFApi, getReportListByMeetingIdPDFApi, getUsersByMeetingIdPDFApi, getMergedReportPDFApi } from "api/pdf";
import { getForEachDecisionByMeetingIdWORDApi, getOneRecordByIdWORDApi, getReportListByMeetingIdWORDApi, getUsersByMeetingIdWORDFApi } from "api/word";
import { createReportFileName, isRoleCheckList } from "app/utils/appHelpers";
import { useState } from "react";
import { useSelector } from "react-redux";
import { NotificationManager } from "react-notifications";
import UnclearSignatureDialog from "./Dialog/UnclearSignatureDialog";
import NotificationDialog from "./Dialog/NotificationDialog";
import LoadingPopUp from "./LoadingPopup";

function ReportMenuGroup({ meeting, decisionId, decisionNo, type = "datatable", iconType = "icon", fromPage = "datatable", visibleMail = true }) {

    const pageType = useSelector((state) => state.meeting.pageType);
    const [unclearSignatureDialogStatus, setUnclearSignatureDialogStatus] = useState(false);
    const [docType, setDocType] = useState('');
    const [oneRecordMailDialogOpen, setOneRecordMailDialogOpen] = useState(false);
    const [oneRecordMailDocType, setOneRecordMailDocType] = useState('agenda');
    const [sendMailSmsDialogOpen, setSendMailSmsDialogOpen] = useState(false);
    const [busy, setBusy] = useState(false);
    const authUser = useSelector(state => state.auth.authUser);
    const userRoles = authUser && authUser.userRoles;

    const withBusy = async (fn) => {
        setBusy(true);
        try {
            await fn();
        } catch (error) {
            NotificationManager.error(error?.message || 'Rapor oluşturulurken hata oluştu.', '', 3000);
        } finally {
            setBusy(false);
        }
    };

    const fullReportMenuItems = [
        { type: 'divider' },
        { title: "PDF Raporları", type: 'header' },
        { title: "PDF Gündem Maddelerini Dosyaya Aktar", type: '1' },
        { title: "PDF Tüm Kararları Dosyaya Aktar", type: '2' },
        { title: "PDF Üyeleri Dosyaya Aktar", type: '3' },
        { title: "PDF Üyeleri Detaylı Olarak Dosyaya Aktar", type: '4' },
        { title: "PDF Katılımcıları Detaylı Olarak Dosyaya Aktar", type: '5' },
        { title: "PDF Birleştirilmiş Rapor", type: '22' },

        ...(pageType !== undefined && (pageType === "1" || pageType === "3") ? [
            { title: "PDF Tek Tek Kararları Dosyaya Aktar(İmza Belirli)", type: '18' },
            { title: "PDF Tek Tek Kararları Dosyaya Aktar(İmza Belirsiz)", type: '19' },
        ] : []),

        { type: 'divider' },
        { title: "WORD Raporları", type: 'header' },
        { title: "WORD Gündem Maddelerini Dosyaya Aktar", type: '6' },
        { title: "WORD Tüm Kararları Dosyaya Aktar", type: '7' },
        { title: "WORD Üyeleri Dosyaya Aktar", type: '12' },
        { title: "WORD Üyeleri Detaylı Olarak Dosyaya Aktar", type: '13' },
        { title: "WORD Katılımcıları Detaylı Olarak Dosyaya Aktar", type: '14' },

        ...(pageType !== undefined && (pageType === "1" || pageType === "3") ? [
            { title: "WORD Tek Tek Kararları Dosyaya Aktar(İmza Belirli)", type: '20' },
            { title: "WORD Tek Tek Kararları Dosyaya Aktar(İmza Belirsiz)", type: '21' },
        ] : []),

        ...(visibleMail ? [
            { type: 'divider' },
            { title: "E-Posta/SMS Gönderim İşlemleri", type: 'header' },
            { title: "E-Posta veya SMS Gönder", type: 'sendMailSms' },
        ] : []),
    ];

    const limitedReportMenuItems = [
        { title: "Raporlar", type: 'header' },
        { title: "PDF Gündem Maddelerini Dosyaya Aktar", type: '1' },
        { title: "PDF Tüm Kararları Dosyaya Aktar", type: '2' },
        { title: "PDF Birleştirilmiş Rapor", type: '22' },
        { title: "WORD Gündem Maddelerini Dosyaya Aktar", type: '6' },
        { title: "WORD Tüm Kararları Dosyaya Aktar", type: '7' },
    ];

    const reportMenuItems = isRoleCheckList(userRoles, [1, 370, 372, 373, 369])
        ? fullReportMenuItems
        : limitedReportMenuItems;




    const agendaReportMenuItems = [
        { title: "PDF Gündem Maddelerini Dosyaya Aktar", type: '1' },
        { title: "PDF Tek Gündemi Dosyaya Aktar", type: '8' },
        { title: "PDF Tek Kararı Dosyaya Aktar", type: '9' },
        { title: "PDF Tek Gündemi E-Posta Gönder", type: '23' },
        { title: "PDF Tek Kararı E-Posta Gönder", type: '24' },
        { title: "WORD Gündem Maddelerini Dosyaya Aktar", type: '6' },
        { title: "WORD Tek Gündemi Dosyaya Aktar", type: '10' },
        { title: "WORD Tek Kararı Dosyaya Aktar", type: '11' }
    ];

    const menu = type === "agenda" ? agendaReportMenuItems : reportMenuItems;

    const reportButtonsClick = async (id, option, meetingId = 0) => {

        if (option.type === '1') {
            await withBusy(() => getReportListByMeetingIdPDFApi(id, "agenda"));
        } else if (option.type === '2') {
            await withBusy(() => getReportListByMeetingIdPDFApi(id, "decision"));
        } else if (option.type === '3') {
            await withBusy(() => getUsersByMeetingIdPDFApi(id, "user"));
        } else if (option.type === '4') {
            await withBusy(() => getUsersByMeetingIdPDFApi(id, "detail"));
        } else if (option.type === '5') {
            await withBusy(() => getUsersByMeetingIdPDFApi(id, "participant"));
        } else if (option.type === '22') {
            await withBusy(() => getMergedReportPDFApi(id));
        } else if (option.type === '12') {
            await withBusy(() => getUsersByMeetingIdWORDFApi(id, "user", "Üye Listesi"));
        } else if (option.type === '13') {
            await withBusy(() => getUsersByMeetingIdWORDFApi(id, "detail", "Detaylı Üye Listesi"));
        } else if (option.type === '14') {
            await withBusy(() => getUsersByMeetingIdWORDFApi(id, "participant", "Katılımcı Listesi"));
        } else if (option.type === '6') {
            await withBusy(async () => {
                if (fromPage === "detail") {
                    await getReportListByMeetingIdWORDApi(meeting.meetingId, "agenda", createReportFileName("GündemListesi", meeting));
                } else {
                    await getReportListByMeetingIdWORDApi(id, "agenda", createReportFileName("GündemListesi", meeting));
                }
            });
        } else if (option.type === '7') {
            await withBusy(() => getReportListByMeetingIdWORDApi(id, "decision", createReportFileName("KararListesi", meeting)));
        } else if (option.type === '8') {
            await withBusy(() => getOneRecordByIdPDFApi(id, decisionId, "agenda"));
        } else if (option.type === '9') {
            await withBusy(() => getOneRecordByIdPDFApi(id, decisionId, "decision"));
        } else if (option.type === '10') {
            await withBusy(() => getOneRecordByIdWORDApi(id, decisionId, "agenda", createReportFileName("Gündem", meeting)));
        } else if (option.type === '11') {
            await withBusy(() => getOneRecordByIdWORDApi(id, decisionId, "decision", createReportFileName("Karar", meeting)));
        } else if (option.type === 'sendMailSms') {
            setSendMailSmsDialogOpen(true);
        } else if (option.type === '18') {
            await withBusy(() => getPDFForEachDecisionByMeetingIdPDFApi(id));
        } else if (option.type === '19') {
            setUnclearSignatureDialogStatus(true);
            setDocType("pdf");
        } else if (option.type === '20') {
            await withBusy(() => getForEachDecisionByMeetingIdWORDApi(id));
        } else if (option.type === '21') {
            setDocType("word");
            setUnclearSignatureDialogStatus(true);
        } else if (option.type === '23') {
            setOneRecordMailDocType('agenda');
            setOneRecordMailDialogOpen(true);
        } else if (option.type === '24') {
            setOneRecordMailDocType('decision');
            setOneRecordMailDialogOpen(true);
        }


    }

    const handleSendMailSmsConfirm = async ({ email, sms, agenda, decision, mailText, smsText, extraFile, userIds, personalizeByName }) => {
        const meetingId = fromPage === "detail" ? meeting.meetingId : meeting.id;
        await withBusy(async () => {
            const notType = email && sms
                ? 'mailSms'
                : email
                    ? 'mail'
                    : sms
                        ? 'sms'
                        : "false";
            const attachmentType = agenda && decision
                ? 'agendaDecision'
                : agenda
                    ? 'agenda'
                    : decision
                        ? 'decision'
                        : "false";

            let extraFileId;
            let extraFileExt;
            if (extraFile) {
                const formData = new FormData();
                formData.append('file', extraFile);
                formData.append('fileType', extraFile.name);
                formData.append('adminUserId', authUser.id);
                formData.append('decisionId', 0);
                formData.append('meetingId', meetingId);
                formData.append('inst', meeting.inst);
                const uploadRes = await postUploadAgendaFileApi(formData);
                if (!uploadRes.status) {
                    NotificationManager.error('Dosya yüklenemedi', '', 3000);
                    return;
                }
                extraFileId = uploadRes.data[0].id;
                extraFileExt = uploadRes.data[0].ext;
            }

            await sendMailByMeetingIdPDFApi(
                meetingId,
                "sendMailSms",
                notType,
                attachmentType,
                mailText,
                smsText,
                extraFileId,
                extraFileExt,
                extraFile && extraFile.name,
                meeting.inst,
                userIds,
                personalizeByName
            );

            NotificationManager.success('Gönderim işlemi başlatıldı.', '', 2000);
        });
    };

    const trigger = iconType === "button" ? (

        <Button variant="text" size="small">
            Raporlar
        </Button>
    ) : (
        <FileCopyIcon style={{ display: 'block', margin: 'auto' }} />

    );


    return (

        <>
            <LoadingPopUp open={busy} blocking message="" />
            <JumboDdMenu
                icon={trigger}
                menuItems={menu}
                onClickCallback={(option) =>
                    reportButtonsClick(fromPage === "detail" ? meeting.meetingId : meeting.id, option)
                }
            />

            {unclearSignatureDialogStatus && (
                <UnclearSignatureDialog
                    open={unclearSignatureDialogStatus}
                    onClose={() => setUnclearSignatureDialogStatus(false)}
                    meetingId={(meeting !== undefined && meeting.id !== undefined) ? meeting.id : 0}
                    docType={docType}
                />
            )}

            {oneRecordMailDialogOpen && (
                <NotificationDialog
                    open={oneRecordMailDialogOpen}
                    onClose={() => setOneRecordMailDialogOpen(false)}
                    onSuccess={(sentCount) => {
                        setTimeout(() => {
                            NotificationManager.success(`${sentCount} kişiye e-posta gönderildi`, '', 4000);
                        }, 400);
                    }}
                    meeting={meeting}
                    decisionId={decisionId}
                    decisionNo={decisionNo ?? meeting?.decisionNo}
                    docType={oneRecordMailDocType}
                />
            )}

            {sendMailSmsDialogOpen && (
                <NotificationDialog
                    open={sendMailSmsDialogOpen}
                    onClose={() => setSendMailSmsDialogOpen(false)}
                    mode="sendMailSms"
                    meeting={meeting}
                    onConfirm={handleSendMailSmsConfirm}
                />
            )}
        </>

    );
}

export default ReportMenuGroup
